"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrtConnectionStatus = void 0;
var SrtConnectionStatus;
(function (SrtConnectionStatus) {
    SrtConnectionStatus["connected"] = "connected";
    SrtConnectionStatus["disconnected"] = "disconnected";
})(SrtConnectionStatus || (exports.SrtConnectionStatus = SrtConnectionStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUE2REEsSUFBWSxtQkFHWDtBQUhELFdBQVksbUJBQW1CO0lBQzNCLDhDQUF1QixDQUFBO0lBQ3ZCLG9EQUE2QixDQUFBO0FBQ2pDLENBQUMsRUFIVyxtQkFBbUIsbUNBQW5CLG1CQUFtQixRQUc5QiJ9